import clsx from 'clsx';
import React from 'react';
import { bsClass, bsStyles, getClassSet, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
import { CustomStyles, State, Style } from '../bootstrap/utils/StyleConfig';
class Label extends React.Component {
  hasContent(children) {
    let result = false;
    React.Children.forEach(children, child => {
      if (result) {
        return;
      }
      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  }
  render() {
    const {
      className,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    };
    return /*#__PURE__*/React.createElement("span", Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }), children);
  }
}
export default bsClass('label', bsStyles([...Object.values(State), Style.DEFAULT, Style.PRIMARY, Style.INVERSE, CustomStyles.SECONDARY, CustomStyles.BRAND, CustomStyles.INFO_INVERSE], Style.DEFAULT, Label));